var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	41735: {
		fallback: () => (() => (__webpack_require__(65043))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	40147: {
		fallback: () => (Promise.all([__webpack_require__.e(9785), __webpack_require__.e(8672), __webpack_require__.e(6981), __webpack_require__.e(1053), __webpack_require__.e(7405)]).then(() => (() => (__webpack_require__(16981))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "antd",

	},
	81603: {
		fallback: () => (__webpack_require__.e(1400).then(() => (() => (__webpack_require__(81400))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^0.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@kne/use-ref-callback",

	},
	64626: {
		fallback: () => (Promise.all([__webpack_require__.e(7308), __webpack_require__.e(7341), __webpack_require__.e(1714)]).then(() => (() => (__webpack_require__(7308))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@kne/react-intl",

	},
	99722: {
		fallback: () => (Promise.all([__webpack_require__.e(5920), __webpack_require__.e(3201)]).then(() => (() => (__webpack_require__(3201))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@kne/react-fetch",

	},
	54539: {
		fallback: () => (Promise.all([__webpack_require__.e(3245), __webpack_require__.e(7405)]).then(() => (() => (__webpack_require__(53245))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	32266: {
		fallback: () => (Promise.all([__webpack_require__.e(1603), __webpack_require__.e(1053), __webpack_require__.e(4247)]).then(() => (() => (__webpack_require__(4247))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^0.2.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@kne/count-down",

	},
	47405: {
		fallback: () => (() => (__webpack_require__(97950))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	24264: {
		fallback: () => (Promise.all([__webpack_require__.e(2089), __webpack_require__.e(6357)]).then(() => (() => (__webpack_require__(6357))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@kne/token-storage",

	},
	67487: {
		fallback: () => (Promise.all([__webpack_require__.e(5614), __webpack_require__.e(6470), __webpack_require__.e(147), __webpack_require__.e(6920)]).then(() => (() => (__webpack_require__(46470))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^0.1.7",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@kne/app-children-router",

	},
	3149: {
		fallback: () => (Promise.all([__webpack_require__.e(5920), __webpack_require__.e(6410), __webpack_require__.e(1603), __webpack_require__.e(5582), __webpack_require__.e(7341), __webpack_require__.e(7405), __webpack_require__.e(783), __webpack_require__.e(1758), __webpack_require__.e(4449)]).then(() => (() => (__webpack_require__(25901))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^0.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@kne/captcha-sender",

	},
	87064: {
		fallback: () => (__webpack_require__.e(4312).then(() => (() => (__webpack_require__(94312))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.2.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@kne/axios-fetch",

	},
	24934: {
		fallback: () => (Promise.all([__webpack_require__.e(8601), __webpack_require__.e(1603), __webpack_require__.e(6293)]).then(() => (() => (__webpack_require__(88601))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@kne/remote-loader",

	},
	58924: {
		fallback: () => (__webpack_require__.e(1591).then(() => (() => (__webpack_require__(41591))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^6.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-helmet",

	},
	93702: {
		fallback: () => (__webpack_require__.e(182).then(() => (() => (__webpack_require__(30182))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "axios",

	},
	53201: {
		fallback: () => (Promise.all([__webpack_require__.e(1603), __webpack_require__.e(9155)]).then(() => (() => (__webpack_require__(19155))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^0.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@kne/use-resize",

	},
	20783: {
		fallback: () => (Promise.all([__webpack_require__.e(9785), __webpack_require__.e(5231), __webpack_require__.e(2563)]).then(() => (() => (__webpack_require__(92563))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^6.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ant-design/icons",

	},
	11758: {
		fallback: () => (Promise.all([__webpack_require__.e(7459), __webpack_require__.e(5496), __webpack_require__.e(1053), __webpack_require__.e(2089), __webpack_require__.e(5802)]).then(() => (() => (__webpack_require__(77459))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@kne/react-form-antd",

	},
	75496: {
		fallback: () => (Promise.all([__webpack_require__.e(9785), __webpack_require__.e(5231), __webpack_require__.e(8672), __webpack_require__.e(2010)]).then(() => (() => (__webpack_require__(12010))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^6.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ant-design/icons",

	},
	91053: {
		fallback: () => (__webpack_require__.e(446).then(() => (() => (__webpack_require__(60446))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "dayjs",

	},
	32564: {
		fallback: () => (Promise.all([__webpack_require__.e(9785), __webpack_require__.e(5231), __webpack_require__.e(2378)]).then(() => (() => (__webpack_require__(22378))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^6.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ant-design/icons",

	},
	12089: {
		fallback: () => (__webpack_require__.e(4416).then(() => (() => (__webpack_require__(74416))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^0.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@kne/local-storage",

	},
	50291: {
		fallback: () => (Promise.all([__webpack_require__.e(2717), __webpack_require__.e(8816), __webpack_require__.e(208), __webpack_require__.e(4881)]).then(() => (() => (__webpack_require__(90208))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@kne/react-form",

	},
	31504: {
		fallback: () => (Promise.all([__webpack_require__.e(2717), __webpack_require__.e(8816), __webpack_require__.e(3549), __webpack_require__.e(4881)]).then(() => (() => (__webpack_require__(13549))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@kne/react-form",

	},
	24881: {
		fallback: () => (__webpack_require__.e(7060).then(() => (() => (__webpack_require__(47060))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@kne/use-event",

	},
	41714: {
		fallback: () => (__webpack_require__.e(628).then(() => (() => (__webpack_require__(20628))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@kne/global-context",

	},
	86293: {
		fallback: () => (__webpack_require__.e(5024).then(() => (() => (__webpack_require__(5024))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^0.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@kne/ensure-slash",

	},
	57830: {
		fallback: () => (__webpack_require__.e(9891).then(() => (() => (__webpack_require__(69891))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^0.1.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@kne/markdown-components-render",

	},
	16381: {
		fallback: () => (Promise.all([__webpack_require__.e(5920), __webpack_require__.e(6410), __webpack_require__.e(8791), __webpack_require__.e(147), __webpack_require__.e(1603), __webpack_require__.e(5496), __webpack_require__.e(5582), __webpack_require__.e(7341), __webpack_require__.e(7405), __webpack_require__.e(783), __webpack_require__.e(2564), __webpack_require__.e(9284)]).then(() => (() => (__webpack_require__(38791))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^0.2.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@kne/entry-selector",

	},
	41705: {
		fallback: () => (Promise.all([__webpack_require__.e(2717), __webpack_require__.e(927), __webpack_require__.e(147), __webpack_require__.e(1603), __webpack_require__.e(5496)]).then(() => (() => (__webpack_require__(47278))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@kne/column-split",

	},
	13389: {
		fallback: () => (__webpack_require__.e(2435).then(() => (() => (__webpack_require__(62435))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^2.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ua-parser-js",

	},
	64469: {
		fallback: () => (__webpack_require__.e(2289).then(() => (() => (__webpack_require__(12289))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.4.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "plantuml-encoder",

	},
	53353: {
		fallback: () => (__webpack_require__.e(1238).then(() => (() => (__webpack_require__(11238))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^0.18.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "xlsx",

	},
	56903: {
		fallback: () => (__webpack_require__.e(107).then(() => (() => (__webpack_require__(10107))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^0.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@kne/create-deferred",

	},
	82620: {
		fallback: () => (__webpack_require__.e(4641).then(() => (() => (__webpack_require__(34641))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^5.11.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "trtc-sdk-v5",

	},
	74697: {
		fallback: () => (__webpack_require__.e(5993).then(() => (() => (__webpack_require__(55993))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^0.1.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@kne/react-box",

	},
	82406: {
		fallback: () => (__webpack_require__.e(1635).then(() => (() => (__webpack_require__(71635))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^4.23.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "agora-rtc-sdk-ng",

	},
	78174: {
		fallback: () => (__webpack_require__.e(9268).then(() => (() => (__webpack_require__(9268))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^2.3.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "md5",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [41735];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"95": [
		64469
	],
	"147": [
		40147
	],
	"340": [
		53353,
		56903
	],
	"403": [
		57830
	],
	"783": [
		20783
	],
	"1053": [
		91053
	],
	"1346": [
		87064
	],
	"1603": [
		81603
	],
	"1705": [
		41705
	],
	"1714": [
		41714
	],
	"1758": [
		11758
	],
	"2089": [
		12089
	],
	"2266": [
		32266
	],
	"2564": [
		32564
	],
	"2620": [
		82620
	],
	"2716": [
		74697
	],
	"3122": [
		24934,
		58924
	],
	"3149": [
		3149
	],
	"4076": [
		78174
	],
	"4264": [
		24264
	],
	"4312": [
		93702
	],
	"4626": [
		64626
	],
	"4881": [
		24881
	],
	"4934": [
		24934
	],
	"5496": [
		75496
	],
	"5582": [
		53201
	],
	"5802": [
		50291,
		31504
	],
	"6215": [
		82406
	],
	"6293": [
		86293
	],
	"6381": [
		16381
	],
	"6920": [
		54539
	],
	"7341": [
		99722
	],
	"7405": [
		47405
	],
	"7487": [
		67487
	],
	"8792": [
		41735
	],
	"9816": [
		13389
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}